import { render, staticRenderFns } from "./FleetDetailSendMail.vue?vue&type=template&id=6bc908e2"
import script from "./FleetDetailSendMail.vue?vue&type=script&setup=true&lang=ts"
export * from "./FleetDetailSendMail.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports